export default __webpack_public_path__ + "static/888-0d64f156517a124bf35a1912200948ee.gif";